<!--
 * @Author: wsx
 * @Date: 2022-03-01 09:54:39
 * @LastEditTime: 2022-03-01 11:19:47
 * @Description: 进度条
 * @FilePath: \hz-digital-twin\src\components\HProgress\index.vue
-->
<template>
  <div class="HProgress">
    <div
      class="chart-column"
      :class="{ animation: column !== 0 }"
      :style="{ width: column + '%' }"
    ></div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  onMounted,
  nextTick,
  watch,
  toRefs,
} from "vue";
import _ from "lodash";
export default defineComponent({
  name: "HProgress",
  components: {},
  props: {
    height: {
      type: [Number, String],
      default: 8,
    },
    percentage: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const state = reactive({
      column: 0,
    });
    const refData = toRefs(state);
    const refresh = async () => {
      state.column = 0;
      _.delay(function () {
        state.column = props.percentage;
      }, 500);
    };
    watch(
      () => props.percentage,
      () => {
        refresh();
      }
    );
    onMounted(() => {
      refresh();
    });
    return { ...refData, refresh };
  },
});
</script>
<style  lang='scss' scoped >
.HProgress {
  margin-bottom: 3px;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  border: 1px solid #0198de;
  .chart-column {
    height: 100%;
    width: 0;
    border-radius: 3px;
    box-shadow: 0 0 7px 1px #00d5ff;
    background-color: #00d5ff;
    &.animation {
      transition: all 2s;
    }
  }
}
</style>
